import type { ReactNode } from "react";

type EmptyStateProps = {
	title: string;
	description?: string;
	icon?: ReactNode;
	action?: ReactNode;
};

export function EmptyState({ title, description, icon, action }: EmptyStateProps) {
	return (
		<div className="flex flex-col items-center justify-center py-16 text-center">
			{icon && <div className="mb-4 text-4xl text-pastel-gray">{icon}</div>}
			<h3 className="text-lg font-semibold text-pastel-black">{title}</h3>
			{description && <p className="mt-2 text-sm text-pastel-gray max-w-sm">{description}</p>}
			{action && <div className="mt-6">{action}</div>}
		</div>
	);
}
